module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "analytics_modal"
  }, [_c('div', {
    staticClass: "modal_body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal_content"
  }, [_c('h2', {
    staticClass: "modal_content_title"
  }, [_vm._v("\n\t\t\t\tTrack 60+ metrics, including:\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "modal_points-div"
  }, [_c('ul', {
    staticClass: "_points"
  }, [_vm._l((this.proBenefits), function(item) {
    return _c('li', {
      staticClass: "_point"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(item) + "\n\t\t\t\t\t")])
  }), _vm._v(" "), _c('li', {
    staticClass: "_point"
  }, [_vm._v("Content Performance")])], 2)]), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.currentUser.request_status !== 'denied') ? _c('div', [_c('v-btn', {
    staticClass: "py-4 button-wrapper",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "round": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.planUpgrade()
      }
    }
  }, [_vm._v("\n\t\t\t\t\tUpgrade\n\t\t\t\t")])], 1) : _vm._e()])]), _vm._v(" "), (_vm.showGetVerifiedModal) ? _c('div', [_c('div', {
    staticClass: "verified-main"
  }, [_c('div', {
    staticClass: "modal-inner"
  }, [_c('div', {
    staticClass: "text-center _title"
  }, [_vm._v("Get verified")]), _vm._v(" "), _c('div', {
    staticClass: "margin-vertical"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "_lable"
  }, [_vm._v("Social channel")]), _vm._v(" "), _c('v-menu', {
    staticClass: "social-type-menu",
    attrs: {
      "content-class": "s-menu__content"
    }
  }, [_c('v-select', {
    staticClass: "social-types-selector py-0",
    class: {
      '_filled': _vm.socialChannel
    },
    attrs: {
      "slot": "activator",
      "placeholder": _vm.socialChannel ? _vm.socialChannel.title : 'Choose',
      "single-line": "",
      "hide-details": ""
    },
    slot: "activator"
  }), _vm._v(" "), _vm._l((_vm.socialChannels), function(channel, i) {
    return _c('div', {
      key: i,
      staticClass: "channel-info",
      class: [((channel.id) + "-menu")],
      on: {
        "click": function($event) {
          _vm.selectedChannel(channel)
        }
      }
    }, [_c('div', {
      staticClass: "_title"
    }, [_vm._v(_vm._s(channel.title))]), _vm._v(" "), _c('div', {
      staticClass: "_tags"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(channel.tags) + "\n\t\t\t\t\t\t\t\t")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "_lable"
  }, [_vm._v("Social Username")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.socialUsername),
      expression: "socialUsername"
    }],
    staticClass: "_socialHandle width100",
    attrs: {
      "placeholder": "Username",
      "type": "text"
    },
    domProps: {
      "value": (_vm.socialUsername)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.socialUsername = $event.target.value
      }
    }
  })], 1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-3 px-3",
    attrs: {
      "round": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.verifiedSocialAttributes()
      }
    }
  }, [_vm._v("Get Verified")]), _vm._v(" "), _c('div', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        _vm.hideModal()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/cross.svg"),
      "width": "11"
    }
  })])], 1)])]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "plans-dialog"
    },
    model: {
      value: (_vm.initPayment),
      callback: function($$v) {
        _vm.initPayment = $$v
      },
      expression: "initPayment"
    }
  }, [_c('payment-card', {
    attrs: {
      "item": _vm.selectedPlan,
      "totalPayable": _vm.totalPayable,
      "closePayment": _vm.closePaymentModal
    }
  })], 1), _vm._v(" "), (_vm.currentUser !== null) ? _c('v-dialog', {
    model: {
      value: (_vm.plansUpgradeModal),
      callback: function($$v) {
        _vm.plansUpgradeModal = $$v
      },
      expression: "plansUpgradeModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Plan Changes")]), _vm._v(" "), (_vm.plansName[_vm.currentUser.plan] == 'Listener' || _vm.currentUser.plan == null) ? _c('v-card-text', [_c('p', [_vm._v("Your current plan is "), _c('b', [_vm._v(" " + _vm._s(_vm.currentUser.plan == null ? "Free Plan" : _vm.plansName[_vm.currentUser.plan]) + " ")]), _vm._v(" and you are trying to upgrade it to "), _c('b', [_vm._v(" Advanced Plan. ")])]), _vm._v(" "), _c('p', [_vm._v("You will remain in your current plan until admin approve your account. Once you verified, you will be charged\n\t\t\t\t\taccording to subscription of current plan and new chosen plan.\n\t\t\t\t\tAre you sure you want to continue?\n\t\t\t\t")])]) : _c('v-card-text', [_c('p', [_vm._v("Your current plan is "), _c('b', [_vm._v(" " + _vm._s(_vm.plansName[_vm.currentUser.plan]) + " ")]), _vm._v(" and you are trying to upgrade it to "), _c('b', [_vm._v(" Advanced Plan. ")])]), _vm._v(" "), _c('p', [_vm._v("This will have an immediate effect and you will be charged according to subscription of current\n\t\t\t\t\tplan and new chosen plan.\n\t\t\t\t\tAre you sure you want to continue?\n\t\t\t\t")])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.verifyUserType()
      }
    }
  }, [_vm._v("Ok\n\t\t\t\t")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hidePlanChangeModal()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal_insight"
  }, [_c('div', [_c('h2', {
    staticClass: "modal_main_title mb-1"
  }, [_vm._v("Unlock analytics insights")]), _vm._v(" "), _c('p', {
    staticClass: "modal_text"
  }, [_vm._v("Get in-depth metrics for all of your content & maximize your growth.")])]), _vm._v(" "), _c('div', {
    staticClass: "modal_graphic mt-3"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/vector..gif"),
      "width": "100%"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal_pricing"
  }, [_c('p', {
    staticClass: "_price"
  }, [_c('span', {
    staticClass: "currency"
  }, [_vm._v("$")]), _vm._v("100"), _c('span', {
    staticClass: "_time"
  }, [_vm._v(" /month")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footnote"
  }, [_vm._v("\n\t\t\t\t\tIf we need to contact you we will send a direct message from "), _c('strong', [_vm._v("@yousoundapp")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a5a1396","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/analyticsModal/index.vue
// module id = 1713
// module chunks = 180